export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID; // Replace with your Google Analytics ID

// Track page views
export const pageview = (url: string, userBpId?: string, label?: string, pathName?: string): void => {
    window.gtag('config', GA_TRACKING_ID, {
        event: `${label}_page_view`,
        event_type: "page_view",
        event_page_path_name: pathName,
        page_path: url,
        ...(userBpId && { user__bp_id: userBpId }), // Include user_id if available
    });
};

// Track custom events
export const event = ({
                          action,
                          category,
                          label,
                          value,
                          event_tag,
                          event_type,
                          page_path,
                          params
                      }: {
    action: string;
    category: string;
    label: string;
    value: number;
    event_tag?: string;
    event_type?: string;
    page_path?: string;
    params?: Record<string, string | number | boolean>
}): void => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
        event_tag: event_tag, // Event Tag
        event_type: event_type,     // Custom event type definition
        page_path: page_path ? page_path : window.location.pathname,
        ...params, // Event-specific dimensions (e.g. recommendation_id)
    });
};
